export enum LOG_CATEGORY {
    ACCOUNT = "Account",
    COMPANY = "Company",
    CLARE_ADMIN = "ClareAdmin",
    SYSTEM = "System",
}
export enum LOG_TYPE {
    USER = "User",
    ACCOUNT = "Account",
    SERVICE_PLANS = "Service Plans",
    LTE_CONFIG = "LTE Config",
    TWO_WAY_CALLING = "Two-Way Calling",
    TWO_WAY_CALLING_NUMBER = "Two-Way Calling Number",
    CS_MONITORING = "Central Station Monitoring",
    FEATURES = "Features",
    DEVICES = "Devices",
    CLAREONE = "ClareOne",
    ACTION = "Actions",
    COMPANY = "Company",
    STAFF = "Staff",
    CUSTOMER = "Customer",
    CENTRAL_STATIONS = "Central Stations",
}
export enum LOG_SUB_TYPE {
    LOG_IN = "Login",
    LOG_OUT = "Logout",
    CREATE = "Create",
    ADD_CLAREONE = "Add ClareOne",
    SUSPEND = "Suspend",
    DELETE = "Delete",
    MOVE = "Move",
    MOVE_IN = "Move In",
    MOVE_OUT = "Move Out",
    CHANGE_PRIMARY_CUSTOMER = "Change Primary Customer",
    SEND_COORDINATES = "Send Coordinates",
    MODIFY = "Modify",
    ACTIVATE = "Activate",
    DEACTIVATE = "Deactivate",
    ENABLE = "Enable",
    DISABLE = "Disable",
    ADD = "Add",
    SENSOR_FOBS_ADD = "Sensors/FOBs - Add",
    SENSOR_FOBS_DELETE = "Sensors/FOBs - Delete",
    SENSOR_FOBS_MODIFY = "Sensors/FOBs - Modify",
    DEV_SETTING_MODIFY = "Device Settings - Modify",
    MASTER_PIN_RESET = "Master PIN reset - Modify",
    INSTALLER_PIN_RESET = "Installer PIN reset - Modify",
    PERIODIC_TEST_SETTING_MODIFY = "Periodic Test Settings - Modify",
    DEALER_LOCKOUT_UPLOAD = "Dealer Lockout - Upload",
    DEALER_LOCKOUT_CREATE = "Dealer Lockout - Create",
    DEALER_LOCKOUT_MODIFY = "Dealer Lockout - Modify",
    DEALER_LOCKOUT_ACTIVATE = "Dealer Lockout - Activate",
    DEALER_LOCKOUT_DEACTIVATE = "Dealer Lockout - Deactivate",
    RESTART_CONTROLLER = "Restart Controller",
    BACKUP_CONTROLLER = "Backup Controller",
    RESTORE_CONTROLLER = "Restore Controller",
    MODIFY_COMPANY_NAME = "Modify Company Name",
    ADD_COMPANY = "Add Company",
}
export const FAIL_MESSAGE = "Failed to log audit event";
export const createAuditLogKey = (category: LOG_CATEGORY, logType: LOG_TYPE, logSubType: LOG_SUB_TYPE) =>
    `${category}__${logType}__${logSubType}`;
